"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _urijs = _interopRequireDefault(require("urijs"));

var _qs = _interopRequireDefault(require("qs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var chooseReportDropdown = function chooseReportDropdown(options, chosen, onChooseReport) {
  return /*#__PURE__*/_react["default"].createElement("select", {
    value: chosen,
    onChange: function onChange(event) {
      return onChooseReport(event.target.value);
    }
  }, options.map(function (value) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: value,
      value: value
    }, value);
  }));
};

var Report = function Report(_ref) {
  var atlasUrl = _ref.atlasUrl,
      history = _ref.history,
      location = _ref.location,
      reports = _ref.reports;

  var query = _qs["default"].parse(location.search.replace(/^\?/, ""));

  var chosenReport = reports.find(function (report) {
    return report.name === query.report;
  }) || reports[0];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row column expanded"
  }, reports.length > 1 && chooseReportDropdown(reports.map(function (report) {
    return report.name;
  }), chosenReport.name, function (report) {
    history.push(Object.assign({}, location, {
      search: _qs["default"].stringify(Object.assign({}, query, {
        report: report
      }))
    }));
  }), /*#__PURE__*/_react["default"].createElement("iframe", {
    name: chosenReport.name,
    src: (0, _urijs["default"])(chosenReport.url, atlasUrl).toString(),
    style: {
      width: "100%",
      height: 1000,
      border: 0
    }
  }));
};

Report.propTypes = {
  atlasUrl: _propTypes["default"].string.isRequired,
  history: _propTypes["default"].object.isRequired,
  location: _propTypes["default"].object.isRequired,
  reports: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired
  })).isRequired
};

var _default = (0, _reactRouterDom.withRouter)(Report);

exports["default"] = _default;